export const isTokenValid = () => {
    let currentTime = new Date()
    let token = localStorage.getItem('access_token')
    let tokenTime = new Date(localStorage.getItem('token_time'))
    let diffTime = currentTime.getTime() - tokenTime.getTime()
    return (token != null || token != "") &&  (diffTime / (1000 * 60) < 180);
}


export const setInputFilter = (textbox, inputFilter) => {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
      textbox.addEventListener(event, function() {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
      });
    });
  }

export const createCSV = (rep) => {
    let csvData= [];
    let newReport = {};
    newReport.updatedDate = rep.updatedDate;
    newReport.id = rep.id
    newReport.isPremium = rep.isPremium
    if (rep.inputData) {
      JSON.parse(rep.inputData).map(el => {
        if (el) {
          let newItem = {};
          newItem.Symbol = el.Symbol;
          newItem.Quantity = Math.abs(el.Quantity);
          newItem.BuyDate = el.BuyDate;
          newItem.BuyPrice = el.BuyPrice;
          newItem.Type = el.Quantity.includes('-') ? 'Sell' : 'Buy';
          csvData.push(newItem);
        }
      })
      let csvContent = "Symbol,Quantity,BuyDate,BuyPrice,Type\n";
      csvContent += [...csvData.map(item => Object.values(item).join(","))].join("\n").replace(/(^\[)|(\]$)/gm, "");

      newReport.csv = csvContent;
      return newReport;
    }
}


// WEBPACK FOOTER //
// ./src/utils/util.js